export function isIndividualUser(user) {
  if (!user) return false;
  if (user.account_type === 'business' && user.tier === 'enterprise') return false;
  return user.account_type !== 'business';
}

export const CONTACT_INQUIRY_EMAIL = 'ReOpsAI@pxd.co.kr';

export function isEnterpriseUser(user) {
  return user?.account_type === 'business' && user?.tier === 'enterprise';
}

export const INDIVIDUAL_TRIAL_TITLE = '금융 도메인 체험 안내';

export const INDIVIDUAL_TRIAL_MESSAGE =
  '퍼소나 생성 체험은 금융 도메인의 퍼소나 생성만 가능합니다.';

export const INDIVIDUAL_TRIAL_ENDED_TITLE = '무료 체험이 종료되었습니다';

export const INDIVIDUAL_TRIAL_ENDED_MESSAGE =
  '체험 토큰을 모두 사용했습니다. 팀 단위 무제한 이용은 이용 문의를 통해 계속 이용하실 수 있습니다.';

export const INDIVIDUAL_QUOTA_EXCEEDED_TEXT = '사용 가능한 토큰이 부족합니다.';

export function getQuotaExceededMessage(user) {
  if (isIndividualUser(user)) {
    return INDIVIDUAL_QUOTA_EXCEEDED_TEXT;
  }
  // Keep enterprise copy in sync with apiClient.QUOTA_EXCEEDED_MESSAGE.
  return '사용 가능한 토큰이 부족합니다. 관리자에게 문의하거나 토큰을 추가해 주세요.';
}

export function shouldBlockTokenGatedStudyFeature(user, { isQuotaExceeded, hasMinimumTier }) {
  if (isIndividualUser(user)) {
    return Boolean(isQuotaExceeded);
  }
  return !hasMinimumTier('basic');
}

export function isPersonaFeatureBlockedError(error) {
  const text = [
    error?.message,
    error?.data?.error,
    error?.data?.message,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return (
    error?.status === 403
    || text.includes('insufficient permissions')
    || text.includes('business company context')
  );
}

export function isTrialEndedError(error) {
  if (error?.data?.trial_ended) return true;
  const message = String(error?.message || error?.data?.message || '').toLowerCase();
  return message.includes('무료 체험 토큰') || message.includes('체험 토큰을 모두');
}
